import Vue from 'vue'
import Vuex from 'vuex'
import system from './modules/system'
import order from './modules/order'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters,
  mutations: {
  },
  actions: {
  },
  modules: {
    system,
    order,
  }
})
